<template>
	<!--START FOOTER-->
	<footer class="footer">
		<div class="container">
			<div class="row">
				<div class="col-md-3 margin-t-20">
					<h4>ALFRED</h4>
					<div class="text-muted margin-t-20">
						<ul class="list-unstyled footer-list">
							<li>
								<a href="#" v-scroll-to="'#home'"> Home </a>
							</li>
							<li>
								<a href="#" v-scroll-to="'#solutions'">Soluções</a>
							</li>
							<!-- <li>
                                <a
                                    href="#"
                                    v-scroll-to="'#howitworks'"
                                >
                                    Depoimentos

                                </a>
                            </li> -->
							<li>
								<a href="#" v-scroll-to="'#contact'"> Contato </a>
							</li>
						</ul>
					</div>
				</div>
				<div class="col-md-3 margin-t-20">
					<h4>Sistema</h4>
					<div class="text-muted margin-t-20">
						<ul class="list-unstyled footer-list">
							<li>
								<b-link href="/login"> Acesse a plataforma </b-link>
							</li>
							<li>
								<b-link href="/termsofuse"> Termos de uso </b-link>
							</li>
							<li>
								<b-link href="/privacypolicy"> Política de Privacidade </b-link>
							</li>
							<li>
								<b-link href="#" v-scroll-to="'#home'"> Sobre nós </b-link>
							</li>
							<li>
								<b-link href="#" v-scroll-to="'#home'"> Carreiras </b-link>
							</li>
							<!-- <li><a href="#">Bookmarks</a></li> -->
						</ul>
					</div>
				</div>

				<div class="col-md-3 margin-t-20">
					<!-- <h4>Subscribe</h4> -->
					<!-- <div class="text-muted margin-t-20">
                            <p>In an ideal world this text wouldn’t exist, a client would acknowledge the importance of having web copy before the design starts.</p>
                        </div> -->
					<!-- <form class="form subscribe">
                            <input placeholder="Email" class="form-control" required>
                            <a href="#" class="submit"><i class="pe-7s-paper-plane"></i></a>
                        </form> -->
				</div>
				<div class="col-md-3 margin-t-20">
					<h4>Suporte</h4>
					<div class="text-muted margin-t-20">
						<ul class="list-unstyled footer-list">
							<!-- <li><a href="">FAQ</a></li> -->
							<!-- <li><a href="">Contact</a></li> -->
							<!-- <li><a href="">Disscusion</a></li> -->
						</ul>
					</div>
				</div>
			</div>
		</div>
	</footer>
	<!--END FOOTER-->
</template>

<script>
	export default {
		name: 'FooterSection',
		props: {},
		methods: {
			navigate: function () {
				// window.location.href = '/register';
				this.$router.push({ name: 'login' })
			}
		}
	}
</script>
